module.exports = __webpack_public_path__ + "static/media/Avatar8.22e40042.svg";